export function createImage(title, description, src, srcFallback) {
    return { title, description, src, srcFallback };
}